import { useEffect, useState } from 'react'
import { fetchPublicReviews, type PublicReviewList } from './api'

/**
 * The sede's public review data (published reviews, Google link and place
 * id), fetched once after mount. Null on the server, during the fetch and on
 * any failure — the caller then renders what it renders without live data,
 * so the prerendered HTML and the hydration never depend on it. Thresholds
 * are the caller's (model.ts `liveOrNull`).
 */
export function usePublicReviews(sedeId: number): PublicReviewList | null {
  const [list, setList] = useState<PublicReviewList | null>(null)
  useEffect(() => {
    let cancelled = false
    fetchPublicReviews(sedeId).then((r) => {
      if (!cancelled && r.ok) setList(r.data)
    })
    return () => {
      cancelled = true
    }
  }, [sedeId])
  return list
}
